// src/pages/SellerIntelligence/Pricing/PricingHub.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPercent, FiTag, FiCalendar, FiArrowLeft } from 'react-icons/fi';
import styles from '../SellerIntelligence.module.css';
import FeatureCardGrid from '../components/FeatureCardGrid';

// Index of the Pricing domain.
const DASHBOARDS = [
  {
    id: 'pricing_strategy',
    title: 'Pricing Strategy Analyzer',
    description: 'What every price change and deal did to margin, measured against what the product was expected to sell anyway rather than against the week before.',
    icon: <FiTag />,
    route: '/dashboard/seller-intelligence/pricing/pricing-strategy',
    action: 'Open →'
  },
  {
    id: 'promotions',
    title: 'Promotion Performance Tracker',
    description: 'Whether each promotion made money after every cost Seller Central does not count — starting with the buyers who would have bought anyway.',
    icon: <FiPercent />,
    route: '/dashboard/seller-intelligence/pricing/promotions',
    action: 'Open →'
  },
  {
    id: 'promo_calendar',
    title: 'Promotional Calendar & Planner',
    description: 'Everything you have run on one axis coloured by what it returned, where a budget would go next, and what will go wrong with what is scheduled.',
    icon: <FiCalendar />,
    route: '/dashboard/seller-intelligence/pricing/promo-calendar',
    action: 'Open →'
  }
];

const PricingHub = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Pricing</h1></div>
          <p>What your prices, deals and promotions did to margin, not just to units</p>
        </div>
      </div>
      <div className={styles.content}>
        <FeatureCardGrid items={DASHBOARDS} />
      </div>
    </div>
  );
};

export default PricingHub;
